import { Box } from "@mui/material"
import { useState } from "react"
import { Outlet } from "react-router-dom"

import { EventsCategoryActions } from "@hooks/profile_page_hooks/useProfileEventFieldData"
import AddToBaseModal from "../../components/popups/addToBaseModal"
import ProfileEventsCheckbox from "../../components/Profile_events_checkbox"
import { ProfileDetails } from "./profileDetails"

import { profileEventCards } from "./profileStyles"
import s from "./styles.module.css"


const Profile = () => {
  const [dataType, setDataType] = useState<EventsCategoryActions>("myEvents")

  const typeDataSet = (evtType: EventsCategoryActions) => {
    setDataType((prev) => (prev = evtType))
  }

  return (
    <div className={s.main}>
      <ProfileDetails currentEvtType={dataType} setEventType={typeDataSet} />
      <AddToBaseModal />
      <Box sx={{ width: "100%" }}>
        <ProfileEventsCheckbox
          onSetEventType={typeDataSet}
          chekedType={dataType}
        />
      </Box>
      <Box sx={profileEventCards}>
        {/* место для карточек с ивентами */}
        <Outlet />
      </Box>
    </div>
  )
}

export default Profile
